import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { CreditService } from '../credit.service';
import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';


@Component({
	selector: 'itpx-credit-details',
	templateUrl: './credit-details.component.html',
	styleUrls: ['./credit-details.component.css']
})
export class CreditDetailsComponent implements OnInit {

	private details: any;
	private id: string;
    private sub: Subscription;
    
    private userGroups: any;

    private fields: Array<any>;
    private buttons=[];

    constructor(
        private service: CreditService,
        private configService: ConfigService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit() {

		this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
			this.service.getCreditDetails(this.id)
				.subscribe(
					body=> {
                        this.details = body.data;
					}
                );
        });

        this.fields = this.service.getDetailsFields();
    }

    ngOnDestroy() {
        this.sub.unsubscribe()
    }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/credit/credit-details/credit-details.component.ts